export default __webpack_public_path__ + "static/media/forPupilImg.305db43c.png";